import { Link } from 'react-router-dom'

import { REDESIGN_ROOT_PATH } from '../../../helpers'
import { TUser } from '../../../utils/types'
import { ReactComponent as UserBadge } from '../assets/userBadge.svg'
import { BeamSideNavigationLink } from '../BeamSideNavigationLink'

interface UserBadgeProps {
  user: TUser
}

export const BeamUserBadge = ({ user }: UserBadgeProps) => {
  return (
    <div className="beam-navigation--user-badge">
      <div className="beam-navigation--user-badge--badge">
        {user.partner.logo && <img src={user.partner.logo} />}
        {!user.partner.logo && <UserBadge />}
      </div>
      <div className="beam-navigation--metadata">
        <div className="beam-navigation--metadata--user">
          <span>
            <Link to={`${REDESIGN_ROOT_PATH}/profile`}>
              {/* This part is here until the backend yields partner info in the initial user payload */}
              {user.partner?.name ?? 'Beam User'}
            </Link>
          </span>
        </div>
        <div className="beam-navigation--metadata--logout">
          <BeamSideNavigationLink path={`${REDESIGN_ROOT_PATH}/logout`}>
            Log out
          </BeamSideNavigationLink>
        </div>
      </div>
    </div>
  )
}
